module.exports = __webpack_public_path__ + "static/media/down-arrow.fe52e04b.svg";